import Call from '../Call.v3';

import qs from 'querystring';

const BidderClickUrlsDaily = {
    get(filters, group_by) {
        return Call(`wbidder/click_urls/daily?${qs.stringify({ ...filters, group_by })}`);
    },
    distinct(field, filters) {
        return Call(`wbidder/click_urls/daily/distinct/${field}?${qs.stringify(filters)}`)
    }
};

export default BidderClickUrlsDaily;



// WEBPACK FOOTER //
// ./src/services/API/components/BidderClickUrlsDaily.js